import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = anon, object = logged in

  useEffect(() => {
    const p = window.location.pathname;
    const authPaths = /(\/admin|dealer-portal|portal-distribuidores|portale-rivenditori|haendlerportal|portal-revendedores)/;
    if (!authPaths.test(p)) { setUser(false); return; }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  };

  const googleSession = async (sessionId) => {
    const { data } = await api.post("/auth/admin/google-session", { session_id: sessionId });
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      // ignore
    }
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, login, logout, googleSession }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
